export default __webpack_public_path__ + "img/app_store_badge.285c78ba.svg";